// import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './AppRouter'
import './index.css'
import { ThemeProvider } from './context/ThemeContext'
import { FooterProvider } from './context/FooterContext'
import { AuthProviderMain } from './main/auth/AuthContextMain'

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <ThemeProvider>
    <AuthProviderMain>
      <FooterProvider>
        <App />
      </FooterProvider>
    </AuthProviderMain>
  </ThemeProvider>
  // </React.StrictMode>
)
